import type { ArticleCard } from '@b4b/shared';

/** Cards show the translation when the server attached one (premium + translateContent). */
export function isTranslated(card: ArticleCard): boolean {
  return card.translation !== null && card.translation !== undefined;
}

export function displayTitle(card: ArticleCard, showOriginal = false): string {
  return !showOriginal && card.translation ? card.translation.title : card.title;
}

export function displaySummary(card: ArticleCard, showOriginal = false): string | null {
  if (!showOriginal && card.translation?.summary) return card.translation.summary;
  return card.summary;
}
